/**
 * Created by Andrey Popov on 1/15/25.
 */

cc.AnimateDelta = function (moveDuration, fadeInDuration, fadeOutDuration, dy) {
    cc.MoveBy.prototype.constructor.call(this);
    this._moveDuration = moveDuration;
    this._fadeInDuration = fadeInDuration;
    this._fadeOutDuration = fadeOutDuration;

    this.initWithDuration(moveDuration + fadeOutDuration, cc.p(0, dy));
    this.easing(cc.easeIn(0.7));
};

cc.AnimateDelta.prototype = Object.assign(Object.create(cc.MoveBy.prototype), {
    constructor: cc.AnimateDelta,

    startWithTarget: function (target) {
        cc.MoveBy.prototype.startWithTarget.call(this, target);

        target.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(target));
        target.setLocalZOrder(1);
        target.setVisible(true);
    },

    update: function (dt) {
        if (dt < this._moveDuration) {
            cc.MoveBy.prototype.update.call(this, dt * this._duration / this._moveDuration);
        }

        if (!this.target) {
            return;
        }

        if (dt < this._fadeInDuration) {
            this.target.opacity = 255 * dt / this._fadeInDuration;
        } else if (dt > this._duration) {
            this.target.opacity = 0;
        } else if (dt > this._moveDuration) {
            this.target.opacity = 255 * (1 - (dt - this._moveDuration) / this._fadeOutDuration);
        } else {
            this.target.opacity = 255;
        }
    }
});